import { useAppContext } from 'providers/AppProvider';

<style>{`

  .section h2 {
      font-size: 1.1rem;
      font-weight: 600;
      margin-bottom: 15px;
      color: #d1d5db;
  }

  .card {
      background: #1C1C1D;
      border-radius: 12px;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .icon {
      font-size: 1.6rem;
      margin-bottom: 10px;
  }

  .label {
      font-size: 14px;
      font-weight: 600;
      color: #a3a3a3;
      letter-spacing: 0.5px;
      margin-bottom: 8px;
      text-transform: uppercase;
  }

  .value {
      font-weight: 800;
      font-size: 32px;
      line-height: 1.1;
  }
}`}</style>;

interface SummaryCardProps {
  sectionTitle: string;
  wmdrUserFields: Array<{
    key: string;
    label: string;
    fmt: string;
    icon: string;
  }>;
  summary: any;
}

const SummaryCard = ({
  sectionTitle,
  wmdrUserFields,
  summary
}: SummaryCardProps) => {
  const {
    getThemeColor,
    config: { isDark }
  } = useAppContext();

  const card: any = {
    background: isDark ? '#141824' : getThemeColor('white'),
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
  };
  const cardLabel: any = {
    fontSize: '16px',
    fontWeight: '600',
    color: isDark ? getThemeColor('white') : '#a3a3a3',
    letterSpacing: '0.5px',
    marginBottom: '8px',
    textTransform: 'uppercase'
  };

  const cardicon: any = {
    fontSize: '1.6rem',
    marginBottom: '10px'
  };

  const grid: any = {
    display: 'grid',
    gap: '20px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 300px))'
  };

  const val: any = {
    fontWeight: '800',
    fontSize: '32px',
    lineHeight: '1.1',
    color: isDark
      ? getThemeColor('white')
      : getThemeColor('light-text-emphasis')
  };

  const sectionh2: any = {
    fontSize: '1.3rem',
    fontWeight: '600',
    marginBottom: '15px',
    color: isDark
      ? getThemeColor('white')
      : getThemeColor('light-text-emphasis')
  };

  return (
    <section className="section pt-0 pb-0" style={{ marginBottom: '40px' }}>
      <h2 style={sectionh2}>{sectionTitle}</h2>
      <div style={grid}>
        {wmdrUserFields.map(field => {
          const value = summary?.summary?.[field.key];
          return (
            <div style={card} key={field.key}>
              <div style={cardicon}>
                <img src={field.icon} alt={`${field.label} Icon`} />
              </div>
              <div style={cardLabel}>{field.label}</div>
              <div style={val}>
                {value
                  ? value.toLocaleString('en-US', {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    })
                  : '0'}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SummaryCard;
